export default __webpack_public_path__ + "static/media/inklink interior1.cbdd9e33.jpg";